'use client';
import e__default from 'react';
import { bannerImagePropTypes } from './banner-image.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerSecondaryImage = renderWithRef('BannerSecondaryImage', bannerImagePropTypes, (n, r)=>{
    let t = new Set([
        'swan-banner-image',
        'swan-banner-secondary-image'
    ]);
    n.imageFocalPoint && t.add(`swan-banner-image-focal-point-${n.imageFocalPoint.replace(/ +/g, '-')}`);
    let { children: m } = n;
    return e__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: r,
        propKeysToRemove: Object.keys(bannerImagePropTypes),
        classNames: t,
        props: n
    }, m);
});

export { BannerSecondaryImage };
